import { render, staticRenderFns } from "./YClientsInit.vue?vue&type=template&id=10027cc8&scoped=true"
import script from "./YClientsInit.vue?vue&type=script&lang=ts"
export * from "./YClientsInit.vue?vue&type=script&lang=ts"
import style0 from "./YClientsInit.vue?vue&type=style&index=0&id=10027cc8&prod&lang=sass&scoped=true"
import style1 from "./YClientsInit.vue?vue&type=style&index=1&id=10027cc8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10027cc8",
  null
  
)

export default component.exports